// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

*{
font-size: 12px;
}

  /* Dropdown Button */
  .dropbtn {
    background-color: #ffc107;
    color: #5d1b8d;
    padding: 16px;
    font-size: 16px;
    border: none;
    margin-right: 10px;
  }
  .dropbtn:hover {
    background-color: #ffc107;
  }
  
  /* The container <div> - needed to position the dropdown content */
  /* .dropdown {
    position: relative;
    display: inline-block;
  } */
  
  /* Dropdown Content (Hidden by Default) */
  /* .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    min-width: 250px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }
   */
  /* Show the dropdown menu on hover */
  /* .dropdown:hover .dropdown-content {
    display: block;
  }

  .dropdown-content.show {
    display: block;
  }
   */


/* 
  .dropdown-content {
    position: absolute;
    top: 100%;
    left: 0;
  }

  
  .dropdown-content {
    display: none;
  }
  
  .dropdown:hover .dropdown-content {
    display: block;
  }
   */

   .dropdown-content {
    display: block;
  }
  
  /* Optional: Adjust the positioning if needed */
  .dropdown-content {
    position: absolute;
    top: 100%;
    left: 0;
  }

  .table-scroll {
    max-height: 600px; /* Adjust this height based on your requirement */
    overflow-y: auto;
    display: inline-block;
    width: 100%;
  }
  
  .table-scroll thead th {
    position: sticky;
    top: 0;
    background-color: #fff; /* Add a background color to the header */
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Optional: Add a shadow effect */
  }
  

  .hoverable {
    position: relative;
  }
  
  .hover-content {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: white;
    border: 1px solid #ccc;
    padding: 5px;
  }
  
  .hover-content.show {
    display: block;
  }
  






  .spinner {
    position: relative;
    width: 50px;
    height: 50px;
    margin: 60px auto;
  }
  
  .circle {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  
  .circle::before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: #333;
    border-radius: 100%;
    animation: sk-bouncedelay 1.2s infinite ease-in-out both;
  }
  
  /* Define colors for each dot here */
  .circle-1::before { background-color: red; }
  .circle-2::before { background-color: orange; animation-delay: -1.15s; }
  .circle-3::before { background-color: yellow; animation-delay: -1.10s; }
  .circle-4::before { background-color: green; animation-delay: -1.05s; }
  .circle-5::before { background-color: blue; animation-delay: -1.00s; }
  .circle-6::before { background-color: indigo; animation-delay: -0.95s; }
  .circle-7::before { background-color: violet; animation-delay: -0.90s; }
  
  /* Continue for all 24 dots */
  
  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      transform: scale(0);
    } 40% {
      transform: scale(1.0);
    }
  }
  
  




  .spinner{
    /*   for centering div */
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      
    /*   spinner div css */
      height : 50px;
      width : 50px;
      border-radius : 50%;
    /*   background-color : red; */
      border : 10px solid #ccc;
      border-top-color : #007bff;
      animation : spin 1s linear infinite;
    }
    
    @keyframes spin{
      0%{
        transform : rotate(0deg);
      }
      100%{
        transform : rotate(360deg);
      }
    }







    `, "",{"version":3,"sources":["webpack://./src/components/complete/details.css"],"names":[],"mappings":";;AAEA;AACA,eAAe;AACf;;EAEE,oBAAoB;EACpB;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;;EAEA,kEAAkE;EAClE;;;KAGG;;EAEH,yCAAyC;EACzC;;;;;;;;IAQE;EACF,oCAAoC;EACpC;;;;;;;IAOE;;;AAGJ;;;;;;;;;;;;;;;IAeI;;GAED;IACC,cAAc;EAChB;;EAEA,+CAA+C;EAC/C;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;EACT;;EAEA;IACE,iBAAiB,EAAE,iDAAiD;IACpE,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,sBAAsB,EAAE,yCAAyC;IACjE,6CAA6C,EAAE,kCAAkC;EACnF;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;;;;;;;EAQA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;EACR;;EAEA;IACE,WAAW;IACX,cAAc;IACd,cAAc;IACd,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,wDAAwD;EAC1D;;EAEA,oCAAoC;EACpC,oBAAoB,qBAAqB,EAAE;EAC3C,oBAAoB,wBAAwB,EAAE,uBAAuB,EAAE;EACvE,oBAAoB,wBAAwB,EAAE,uBAAuB,EAAE;EACvE,oBAAoB,uBAAuB,EAAE,uBAAuB,EAAE;EACtE,oBAAoB,sBAAsB,EAAE,uBAAuB,EAAE;EACrE,oBAAoB,wBAAwB,EAAE,uBAAuB,EAAE;EACvE,oBAAoB,wBAAwB,EAAE,uBAAuB,EAAE;;EAEvE,6BAA6B;;EAE7B;IACE;MACE,mBAAmB;IACrB,EAAE;MACA,qBAAqB;IACvB;EACF;;;;;;;EAOA;IACE,wBAAwB;MACtB,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,gCAAgC;;IAElC,sBAAsB;MACpB,aAAa;MACb,YAAY;MACZ,mBAAmB;IACrB,8BAA8B;MAC5B,wBAAwB;MACxB,0BAA0B;MAC1B,mCAAmC;IACrC;;IAEA;MACE;QACE,wBAAwB;MAC1B;MACA;QACE,0BAA0B;MAC5B;IACF","sourcesContent":["\r\n\r\n*{\r\nfont-size: 12px;\r\n}\r\n\r\n  /* Dropdown Button */\r\n  .dropbtn {\r\n    background-color: #ffc107;\r\n    color: #5d1b8d;\r\n    padding: 16px;\r\n    font-size: 16px;\r\n    border: none;\r\n    margin-right: 10px;\r\n  }\r\n  .dropbtn:hover {\r\n    background-color: #ffc107;\r\n  }\r\n  \r\n  /* The container <div> - needed to position the dropdown content */\r\n  /* .dropdown {\r\n    position: relative;\r\n    display: inline-block;\r\n  } */\r\n  \r\n  /* Dropdown Content (Hidden by Default) */\r\n  /* .dropdown-content {\r\n    display: none;\r\n    position: absolute;\r\n    background-color: #f1f1f1;\r\n    min-width: 250px;\r\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\r\n    z-index: 1;\r\n  }\r\n   */\r\n  /* Show the dropdown menu on hover */\r\n  /* .dropdown:hover .dropdown-content {\r\n    display: block;\r\n  }\r\n\r\n  .dropdown-content.show {\r\n    display: block;\r\n  }\r\n   */\r\n\r\n\r\n/* \r\n  .dropdown-content {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n  }\r\n\r\n  \r\n  .dropdown-content {\r\n    display: none;\r\n  }\r\n  \r\n  .dropdown:hover .dropdown-content {\r\n    display: block;\r\n  }\r\n   */\r\n\r\n   .dropdown-content {\r\n    display: block;\r\n  }\r\n  \r\n  /* Optional: Adjust the positioning if needed */\r\n  .dropdown-content {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n  }\r\n\r\n  .table-scroll {\r\n    max-height: 600px; /* Adjust this height based on your requirement */\r\n    overflow-y: auto;\r\n    display: inline-block;\r\n    width: 100%;\r\n  }\r\n  \r\n  .table-scroll thead th {\r\n    position: sticky;\r\n    top: 0;\r\n    background-color: #fff; /* Add a background color to the header */\r\n    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Optional: Add a shadow effect */\r\n  }\r\n  \r\n\r\n  .hoverable {\r\n    position: relative;\r\n  }\r\n  \r\n  .hover-content {\r\n    display: none;\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    background-color: white;\r\n    border: 1px solid #ccc;\r\n    padding: 5px;\r\n  }\r\n  \r\n  .hover-content.show {\r\n    display: block;\r\n  }\r\n  \r\n\r\n\r\n\r\n\r\n\r\n\r\n  .spinner {\r\n    position: relative;\r\n    width: 50px;\r\n    height: 50px;\r\n    margin: 60px auto;\r\n  }\r\n  \r\n  .circle {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n  \r\n  .circle::before {\r\n    content: '';\r\n    display: block;\r\n    margin: 0 auto;\r\n    width: 15%;\r\n    height: 15%;\r\n    background-color: #333;\r\n    border-radius: 100%;\r\n    animation: sk-bouncedelay 1.2s infinite ease-in-out both;\r\n  }\r\n  \r\n  /* Define colors for each dot here */\r\n  .circle-1::before { background-color: red; }\r\n  .circle-2::before { background-color: orange; animation-delay: -1.15s; }\r\n  .circle-3::before { background-color: yellow; animation-delay: -1.10s; }\r\n  .circle-4::before { background-color: green; animation-delay: -1.05s; }\r\n  .circle-5::before { background-color: blue; animation-delay: -1.00s; }\r\n  .circle-6::before { background-color: indigo; animation-delay: -0.95s; }\r\n  .circle-7::before { background-color: violet; animation-delay: -0.90s; }\r\n  \r\n  /* Continue for all 24 dots */\r\n  \r\n  @keyframes sk-bouncedelay {\r\n    0%, 80%, 100% {\r\n      transform: scale(0);\r\n    } 40% {\r\n      transform: scale(1.0);\r\n    }\r\n  }\r\n  \r\n  \r\n\r\n\r\n\r\n\r\n  .spinner{\r\n    /*   for centering div */\r\n      position: absolute;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%);\r\n      \r\n    /*   spinner div css */\r\n      height : 50px;\r\n      width : 50px;\r\n      border-radius : 50%;\r\n    /*   background-color : red; */\r\n      border : 10px solid #ccc;\r\n      border-top-color : #007bff;\r\n      animation : spin 1s linear infinite;\r\n    }\r\n    \r\n    @keyframes spin{\r\n      0%{\r\n        transform : rotate(0deg);\r\n      }\r\n      100%{\r\n        transform : rotate(360deg);\r\n      }\r\n    }\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
